import { render, staticRenderFns } from "./labs.vue?vue&type=template&id=701a634d"
import script from "./labs.vue?vue&type=script&lang=js"
export * from "./labs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports